module.exports = __webpack_public_path__ + "img/dance-test-icon8.3f63810b.png";